module.exports = __webpack_public_path__ + "img/female-adult-head.5f447677.svg";